<template>
    <div class="wrapper ">
        <Sidebar />
        <div class="main-panel" id="main-panel">
            <Header />
            <div class="panel-header panel-header-sm">
                <canvas id="bigDashboardChart"></canvas>
            </div>
            <div class="content">
                <Loading v-if="loading === true"/>
                <transition name="modal" v-if="editingEvent != null">
                    <div class="modal-mask">
                        <div class="modal-wrapper">
                            <div class="modal-container">
                                <Alert v-if="errorMessage.length > 0" :message="errorMessage" :error="true"/>
                                <Alert v-if="successMessage.length > 0" :message="successMessage" :error="false"/>
                                <div class="modal-header">
                                    <slot name="header">
                                        <h3 v-if="editing === true" class="mb-0">Edit Event</h3>
                                        <h3 v-else class="mb-0">Create New Event</h3>
                                        <button v-if="editing === true && editingNotification == false" @click="editingNotification = true" class="btn btn-primary modal-default-button float-right">
                                            Notification
                                        </button>
                                    </slot>
                                </div>
                                <div v-if="editingNotification === true">
                                    <div class="modal-body">
                                        <slot name="body">
                                            <div class="row mb-5">
                                                <div class="col-12">
                                                    <label>*Notification Title</label>
                                                    <input v-model="notificationTitle" type="text" placeholder="* Title" class="form-control"/>
                                                </div>
                                            </div>
                                            <div class="row mb-1">
                                                <div class="col-12">
                                                    <label>*Notification Message</label>
                                                    <input v-model="notificationMessage" type="text" placeholder="* Message" class="form-control"/>
                                                </div>
                                            </div>
                                        </slot>
                                    </div>
                                    <div>
                                        <slot name="footer">
                                            <button class="btn btn-primary" @click="editingNotification = false; successMessage = ''; errorMessage = '';">
                                                Back
                                            </button>
                                            <button class="btn btn-primary modal-default-button float-right" @click="sendNotification()">
                                                Send Notification
                                            </button>
                                        </slot>
                                    </div>
                                </div>
                                <div v-else>
                                    <div class="modal-body">
                                        <slot name="body">
                                            <div class="row">
                                                <div class="col-lg-6 mb-3">
                                                    <label>*Title</label>
                                                    <input v-model="editingEvent.title" type="text" placeholder="* Title" class="form-control"/>
                                                </div>
                                                 <div class="col-lg-3 mb-3">
                                                    <label>*Event URL</label>
                                                    <input v-model="editingEvent.eventUrl" placeholder="*Event URL" class="form-control"/>
                                                </div>
                                                <div class="col-lg-3 mb-3">
                                                    <label>Price</label>
                                                    <input v-model="editingEvent.price" type="number" min="0.1" step="0.1" placeholder="Price" class="form-control"/>
                                                </div>
                                            </div>
                                            <div class="row mb-3">
                                                <div class="col">
                                                    <label>*Start Date</label>
                                                    <Datepicker v-model="editingEvent.start" placeholder="* Select Start Date & Time" />
                                                </div>
                                                <div class="col">
                                                    <label>Start Time</label>
                                                    <VueTimepicker input-width="100%" v-model="editingEvent.startingTime" format="hh:mm A" :minute-interval="5" />
                                                </div>
                                                <div class="col">
                                                    <label>*End Date</label>
                                                    <Datepicker v-model="editingEvent.end" placeholder="* Select End Date & Time" />
                                                </div>
                                                <div class="col">
                                                    <label>End Time</label>
                                                    <VueTimepicker input-width="100%" v-model="editingEvent.endingTime" format="hh:mm A" :minute-interval="5" />
                                                </div>
                                            </div>
                                            <div class="row mt-3">
                                                <div class="col">
                                                    <label>Description</label>
                                                    <textarea v-model="editingEvent.description" placeholder="Description" class="form-control"/>
                                                </div>
                                            </div>
                                            <div class="row mt-3">
                                                <div v-if="editingEvent.image != null" class="col-6">
                                                    <div class="card">
                                                        <div class="card-body">
                                                            <img :src="editingEvent.image"/>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col">
                                                    <Dropzone name="dropzone" id="dropzone" ref="imageDropzone"
                                                            :options="imageDropzoneOptions"
                                                            :useCustomSlot=true
                                                            v-on:vdropzone-sending="appendFileName"
                                                            @vdropzone-file-added="fileInDropzone=true"
                                                            @vdropzone-removed-file="fileInDropzone=false">
                                                        <div class="dropzone-custom-content">
                                                            <h5 class="dropzone-custom-title">Click here or drag and drop an image</h5>
                                                            <div class="subtitle dropzone-custom-sub">accepted file types: png, jpg, jpeg</div>
                                                        </div>
                                                    </Dropzone>
                                                    <button v-if="fileInDropzone"  class="btn btn-outline-danger ml-4" @click="removeImage">Clear Dropzone</button>
                                                </div>
                                            </div>
                                        </slot>
                                    </div>
                                    <div>
                                        <slot name="footer">
                                            <button class="btn btn-danger btn-orange" style="font-size: 14px;" @click="deleteEvent(editingEvent.id)">
                                                <i class="fa fa-trash mr-2"></i>Delete
                                            </button>
                                            <button class="btn btn-primary modal-default-button float-right" @click="editingEvent=null">
                                                Close
                                            </button>
                                            <button v-if="editing" class="btn btn-primary modal-default-button float-right" @click="updateEvent(editingEvent)">
                                                Update
                                            </button>
                                            <button v-else class="btn btn-primary modal-default-button float-right mr-3" @click="createEvent(editingEvent)">
                                                Create
                                            </button>
                                        </slot>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </transition>

                <div id="row">
                    <div class="card">
                        <div class="card-body">
                            <h5>Pick an Institute</h5>
                            <select class="form-control custom-dropdown mb-5" v-model="selectedMuseum" @change="getMuseumEvents()">
                                <option disabled value="">Institutes</option>
                                <option v-for="museum in museums" :key="museum.id" :value="museum">{{ museum.name }}</option>
                            </select>
                        </div>
                    </div>
                </div>

                <div id="row">
                    <Alert v-if="errorMessage.length > 0" :message="errorMessage" :error="true"/>
                    <Alert v-if="successMessage.length > 0" :message="successMessage" :error="false"/>
                    <div class="card">
                        <div class="card-header">
                            <small><b>Click on a date to add an event</b></small>
                        </div>
                        <div class="card-body">
                            <FullCalendar
                                defaultView="dayGridMonth"
                                selectable=true
                                :plugins="calendarPlugins"
                                :events="calendarEvents"
                                @dateClick="handleDateClick"
                                @eventClick="eventClicked"
                                eventTextColor='white'
                                displayEventEnd=true
                                displayEventTime=true
                            />
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    </div>
</template>

<style lang='scss'>
    @import '~@fullcalendar/core/main.css';
    @import '~@fullcalendar/daygrid/main.css';
</style>

<script>
    // Dropzone
    import Dropzone from 'vue2-dropzone';
    import 'vue2-dropzone/dist/vue2Dropzone.min.css';

    // Calendar Plugins
    import FullCalendar from '@fullcalendar/vue';
    import dayGridPlugin from '@fullcalendar/daygrid';
    import interactionPlugin from '@fullcalendar/interaction';

    // Time & Date Pickers
    import Datepicker from 'vuejs-datepicker';
    import VueTimepicker from 'vue2-timepicker'
    import 'vue2-timepicker/dist/VueTimepicker.css'

    // Controllers
    import Events from '../controllers/events.controller';
    import Museums from '../controllers/museum.controller';
    import Notifications from '../controllers/notifications.controller';

    // Services
    import isSuperAdmin from '../services/jwt/isSuperAdmin';
    import getUID from '../services/jwt/getUID';

    export default {
        name: 'Listings',
        components: {
            Datepicker,
            VueTimepicker,
            FullCalendar,
            Dropzone
        },
        data: function() {
            return {
                editing: false,
                newEventID: null,
                editingEvent: null,
                calendarPlugins: [
                    dayGridPlugin,
                    interactionPlugin
                ],
                calendarEvents: [],
                events: [],
                event: {
                    museumID: ''
                },
                museums: '',
                selectedMuseum: '',
                loading: false,
                errorMessage: '',
                successMessage: '',
                isSuperAdmin: isSuperAdmin(localStorage.getItem('superAdmin')),
                imageDropzoneOptions: {
                    url: (process.env.VUE_APP_API_URL + '/listing/upload/13') || "http://localhost:3001/api/listing/upload/13",
                    maxFilesize: 50, // Mb
                    maxFiles: 1,
                    autoProcessQueue: false,
                    acceptedFiles: '.png,.jpg,.jpeg',
                    header: {
                        'Authorization': 'Bearer ' + localStorage.getItem('access_token')
                    }
                },
                fileInDropzone: false,
                editingNotification: false,
                notificationTitle: '',
                notificationMessage: ''
            }
        },

        beforeMount: async function() {
            this.loading = true;

            // Fetch all the information that we need for the view
            if (this.isSuperAdmin == true) {
                this.museums = await Museums.getAll();
            } else {
                let uid = await getUID(localStorage.getItem('superAdmin'));
                this.museums = await Museums.getCuratorMuseums(uid);
                this.selectedMuseum = this.museums[0];
                await this.getMuseumEvents();
            }

            this.loading = false;
        },

        methods: {
            async createEvent(event) {
                // Reset the alert messages
                this.successMessage = '';
                this.errorMessage = '';

                this.loading = true;

                if (!this.selectedMuseum) {
                    this.errorMessage = 'Pick a valid institute';
                    this.loading = false;
                    return;
                }

                if (!event.start || !event.end || !event.title || !event.eventUrl) {
                    this.errorMessage = 'A mandatory field is missing.';
                    this.loading = false;
                    return;
                }
                event.museumID = this.selectedMuseum.id;

                // Format the time for the API
                event.startingTime = this.formatTime(event.startingTime);
                event.endingTime = this.formatTime(event.endingTime);

                if (event.price === '0') {
                    event.price = null;
                }

                let created = await Events.createNew(event);

                if (created === false) {
                    this.errorMessage = 'Something went wrong creating your event';
                } else if (created.error) {
                    this.errorMessage = created.error;
                } else {
                    this.newEventID = created.id;
                    if (this.$refs.imageDropzone.dropzone.files.length > 0) {
                        this.uploadImage();
                    } else {
                        this.successMessage = 'Event created successfully';
                        await this.getMuseumEvents(); // Refresh the data
                        this.editingEvent = null;
                    }
                }

                this.loading = false;
            },

            async updateEvent(event) {
                // Reset the alert messages
                this.successMessage = '';
                this.errorMessage = '';

                this.loading = true;

                if (!this.selectedMuseum) {
                    this.errorMessage = 'Pick a valid institute';
                    this.loading = false;
                    return;
                }

                if (!event.start || !event.end || !event.title || !event.eventUrl) {
                    this.errorMessage = 'A mandatory field is missing.';
                    this.loading = false;
                    return;
                }
                event.museumID = this.selectedMuseum.id;

                // Format the time for the API
                event.startingTime = this.formatTime(event.startingTime);
                event.endingTime = this.formatTime(event.endingTime);

                await Events.update(event)
                    .then((res) => {
                        if (res.error !== undefined) {
                            this.errorMessage = res.error;
                        } else {
                            if (this.$refs.imageDropzone.dropzone.files.length > 0) {
                                this.uploadImage();
                            } else {
                                this.successMessage = 'Event updated successfully';
                                this.getMuseumEvents(); // Refresh the data
                                this.editingEvent = null;
                            }
                        }
                        this.loading = false;
                    })
                    .catch((_) => {
                        this.errorMessage = 'Something went wrong updating your event';
                        this.loading = false;
                    });
            },

            formatTime(time) {
                return this.validTime(time) ? time.hh + ":" + time.mm + time.A : null;
            },

            validTime(time) {
                return !this.isEmpty(time.hh) && !this.isEmpty(time.mm) && !this.isEmpty(time.A)
            },

            isEmpty(value) {
                return value === "" || value === null || value === undefined;
            },

            uploadImage() {
                this.$refs.imageDropzone.processQueue();
            },

            removeImage() {
                this.$refs.imageDropzone.removeAllFiles();
            },

            async appendFileName(file, xhr, formData) {
                file.upload.filename = Date.now() + file.upload.filename.slice(file.upload.filename.lastIndexOf('.'), file.upload.filename.length);

                let eventID = this.editingEvent.id == undefined ? this.newEventID : this.editingEvent.id;

                let uploaded = await Events.uploadImage(eventID, file.upload.filename, file.dataURL);
                if (uploaded == true) {
                    this.successMessage = this.editing == true ? "Image uploaded successfully" : "Event created successfully";
                    this.getMuseumEvents(); // Refresh the data
                    this.editingEvent = null;
                } else {
                    this.errorMessage = "Something went wrong with uploading your image"
                }
            },

            async getMuseumEvents() {
                this.errorMessage = "";
                this.error = false;

                this.calendarEvents = [];

                this.events = await Events.getByMuseumID(this.selectedMuseum.id);
                if (this.events.length > 0) {
                    this.events.forEach(event => {
                        this.calendarEvents.push({
                            id: event.id,
                            allDay: true,
                            title: event.title,
                            description: event.description,
                            price: event.price,
                            eventUrl: event.event_url,
                            image: event.image,
                            start: this.format(new Date(event.start_date)),
                            // The time object is required by the time select dropdown
                            startingTime: {
                                hh: event.start_time ? (parseInt(event.start_time.split(':')[0]) < 10 ? "0" + event.start_time.split(':')[0] : event.start_time.split(':')[0]) : null,
                                mm:  event.start_time ? (event.start_time.slice(-4).slice(0, 2)) : null,
                                A:  event.start_time ? (event.start_time.slice(-2).toUpperCase()) : null
                            },
                            end: this.format(new Date(event.display_end_date)),
                            actual_end: this.format(new Date(event.end_date)),
                            // The time object is required by the time select dropdown
                            endingTime: {
                                hh: event.end_time ? (parseInt(event.end_time.split(':')[0]) < 10 ? "0" + event.end_time.split(':')[0] : event.end_time.split(':')[0]) : null,
                                mm: event.end_time ? (event.end_time.slice(-4).slice(0, 2)) : null,
                                A: event.end_time ? event.end_time.slice(-2).toUpperCase() : null
                            }
                        });
                    });
                }

            },

            async deleteEvent(eventID) {
                if (window.confirm("Are you sure you want to delete this event? This action cannot be undone.")) {
                    let deleted = await Events.delete(eventID);

                    if (deleted == true) {
                        // Event deleted successfully, refresh the data
                        this.getMuseumEvents();
                    } else {
                        this.errorMessage = 'Something went wrong with deleting the listing';
                    }
                    this.editingEvent = null;
                }
            },

            // Formats the date for the calendar
            format(date) {
                var mm = date.getMonth() + 1;
                var dd = date.getDate() + 1;

                return [
                    date.getFullYear(),
                    (mm > 9 ? '' : '0') + mm,
                    (dd > 9 ? '' : '0') + dd
                ].join('-');
            },

            // Event emitters to handle calendar operations
            handleDateClick(arg) {
                this.successMessage = '';
                this.errorMessage = '';
                this.error = false;

                if (!this.selectedMuseum) {
                    this.errorMessage = "Pick a valid institute first";
                    this.error = true;
                    return;
                }

                this.editing = false;
                this.editingEvent = {
                    start: arg.date,
                    startingTime: {},
                    endingTime: {}
                };
            },

            eventClicked(info) {
                this.successMessage = '';
                this.errorMessage = '';
                this.error = false;

                this.editing = true;

                let actualEnd = new Date(info.event.extendedProps.actual_end);
                actualEnd.setDate(actualEnd.getDate() + 1);

                if (actualEnd == null) {
                    actualEnd = info.event.start;
                }

                this.editingEvent = {
                    id: info.event.id,
                    title: info.event.title,
                    start: info.event.start,
                    startingTime: info.event.extendedProps.startingTime,
                    end: actualEnd,
                    endingTime: info.event.extendedProps.endingTime,
                    description: info.event.extendedProps.description,
                    price: info.event.extendedProps.price,
                    eventUrl: info.event.extendedProps.eventUrl,
                    image: info.event.extendedProps.image
                };
            },

            async sendNotification() {
                if (!this.notificationTitle || !this.notificationMessage) {
                    this.errorMessage = "You must provide a title and a message for the notification";
                    return;
                }

                this.loading = true;

                let eventID = this.editingEvent.id;

                let sent = await Notifications.sendForEvent(eventID, this.notificationTitle, this.notificationMessage);

                if (sent === true) {
                    this.successMessage = "Notification sent successfully!"
                    this.editingEvent = null;
                } else if (sent.error) {
                    this.errorMessage = sent.error;
                } else {
                    this.errorMessage = "Something went wrong while sending your notification";
                }

                this.notificationTitle = '';
                this.notificationMessage = '';

                this.loading = false;
            }
        }
    }
</script>